import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';

import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  hasAccountProfile$: Observable<boolean> = of(false);

  constructor(
    private storeService: StoreService
  ) { }

  private init(): void {
    this.hasAccountProfile$ = this.storeService.hasAccountProfile();
  }

  ngOnInit(): void {
    this.init();
  }
}
